import React from "react";
import Grid from "../layout/grid";

export default function (props) {
    return (
        <Grid cols={props.cols}>
            <div className="form-group" style={props.style || {}}>
                <label htmlFor={props.name}>{props.label}</label>
                <input
                    className="form-control"
                    type="time"
                    value={props.value || ""}
                    onChange={props.onChange}
                    disabled={props.readOnly}
                    step="60" // 60 segundos → remove segundos
                />
            </div>
        </Grid>
    );
}
